export default "__VITE_ASSET__CKRPQv2D__"